export default "__VITE_ASSET__CBcBr_pl__"